import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  AssetService,
  HttpAuthInterceptor,
  LayoutService,
  LoadingService,
  LoggingService,
} from '@aksia/services';
import { UserRoleService } from '@aksia/services';
import {
  ASSETS_SERVICE_TOKEN,
  AUTHENTICATION_SERVICE_TOKEN,
  ENVIRONMENT_TOKEN,
  IUiControlSettings,
  LAYOUT_SERVICE_TOKEN,
  LOADING_SERVICE_TOKEN,
  LOGGING_SERVICE_TOKEN,
  TViewItem,
  USER_ROLE_SERVICE_TOKEN,
} from '@aksia/infrastructure';
import { AuthenticationService } from './services/authentication.service';
import { AssetTypeEnum } from '@aksia/enums';
import { AssetViewMap, TAssetTeamView } from '@aksia/models';

import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideRouter(appRoutes),
    {
      provide: ENVIRONMENT_TOKEN,
      useValue: environment,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    },
    {
      provide: LOADING_SERVICE_TOKEN,
      useExisting: LoadingService,
    },
    {
      provide: AUTHENTICATION_SERVICE_TOKEN,
      useExisting: AuthenticationService,
    },
    {
      provide: USER_ROLE_SERVICE_TOKEN,
      useExisting: UserRoleService,
    },
    {
      provide: LAYOUT_SERVICE_TOKEN,
      useExisting: LayoutService<
        AssetTypeEnum,
        TAssetTeamView,
        TViewItem<IUiControlSettings>,
        AssetViewMap
      >,
    },
    {
      provide: ASSETS_SERVICE_TOKEN,
      useExisting: AssetService,
    },
    {
      provide: LOGGING_SERVICE_TOKEN,
      useExisting: LoggingService,
    },
  ],
};
